export default __webpack_public_path__ + "31698d471698dd1919d7a9116d623084.png";